// extracted by mini-css-extract-plugin
export var completionBody = "_m5-2";
export var completionCard = "_m5-0";
export var completionFooter = "_m5-3";
export var completionTitle = "_m5-1";